import {AxiosResponse} from "axios";
import {PageableModel} from "../../common/models/table";
import http from "../../common/services/httpService";
import {Api, apiUrls, SortingAndFilteringParams} from "../../helpers/api";
import {FerryOrdersParkingModel} from "../models/ferryOrdersParking";
import {NonFerryOrdersParkingModel} from "../models/nonFerryOrdersParking";

export class ParkingService {
    public static async getAllParkingsForFerryOrders(sortingAndFilteringParams?: SortingAndFilteringParams): Promise<AxiosResponse<PageableModel<FerryOrdersParkingModel>>> {
        return await http.get<PageableModel<FerryOrdersParkingModel>>(
            Api.addSortingAndFilteringParams(Api.getUrl(apiUrls.place.ferryOrdersParkings), sortingAndFilteringParams));
    }

    public static async getAllParkingsForNonFerryOrders(sortingAndFilteringParams?: SortingAndFilteringParams): Promise<AxiosResponse<PageableModel<NonFerryOrdersParkingModel>>> {
        return await http.get<PageableModel<NonFerryOrdersParkingModel>>(
            Api.addSortingAndFilteringParams(Api.getUrl(apiUrls.place.nonFerryOrdersParkings), sortingAndFilteringParams));
    }
}
